/* useOdmenaTipare — odměna tipaři z profilu přihlášeného poradce (15. 10. 2026).
 *
 * Jedno místo, odkud ji berou Závěr analýzy, složka klienta, kino, plátno B
 * prezentace i snímek Závěr v plánu — ať všechny slibují totéž (SPEC §6.5).
 * Text věty skládá lib/doporuceni/odmenaTipare.js (vetaOdmeny, radekOdmeny).
 *
 * Vrací `{ castka, mena, podminka }`, nebo null = bez částky (texty jen
 * poděkují). Měna je ta, ve které poradce částku zadal (backend ji razítkuje
 * při uložení); chybí-li, vezme se měna ZEMĚ tenanta — nikdy jazyk.
 *
 * Mimo ProfileProvider (testy, izolovaný náhled) vrací null — hook se volá
 * vždy, výjimka z useProfile skončí v catch (stejný vzor jako PodkladyKlienta).
 *
 * OBNOVA PO NÁVRATU DO OKNA (kontrola 15. 10.): čip „Poděkování bez částky ·
 * Nastavit“ otevře Nastavení v nové záložce. ProfileContext se načítá jen při
 * startu, takže po uložení 500 Kč by otevřená analýza dál psala „bez
 * částky“ až do obnovení stránky. Při návratu do okna (focus /
 * visibilitychange) se profil načte znovu — nejvýš jednou za 10 s pro
 * všechny instance hooku dohromady.
 */
import { useEffect, useMemo } from "react";
import * as Profil from "@/contexts/ProfileContext";
import { menaTenanta } from "@/lib/tenantMena";
import { normOdmena } from "@/lib/doporuceni/odmenaTipare";
import { podpisDoporuceni } from "@/lib/crm/zpravaDoporuceni";

function useProfilVolitelne() {
  try { return Profil.useProfile(); } catch { return null; }
}

export const OBNOVA_ODMENY_MS = 10000;
let posledniObnova = 0;
/** Jen pro testy: vynuluje časovač obnovy. */
export function _resetObnovyOdmeny() { posledniObnova = 0; }

function useObnovaPoNavratu(refresh) {
  useEffect(() => {
    if (typeof window === "undefined" || typeof refresh !== "function") return undefined;
    const obnov = () => {
      if (typeof document !== "undefined" && document.visibilityState === "hidden") return;
      const ted = Date.now();
      if (ted - posledniObnova < OBNOVA_ODMENY_MS) return;
      posledniObnova = ted;
      try { Promise.resolve(refresh()).catch(() => {}); } catch { /* profil je nepovinný */ }
    };
    window.addEventListener("focus", obnov);
    document.addEventListener("visibilitychange", obnov);
    return () => {
      window.removeEventListener("focus", obnov);
      document.removeEventListener("visibilitychange", obnov);
    };
  }, [refresh]);
}

export default function useOdmenaTipare() {
  const ctx = useProfilVolitelne();
  useObnovaPoNavratu(ctx?.refresh);
  const p = ctx?.profile || null;
  const castka = p?.referral_reward_amount;
  const mena = p?.referral_reward_currency;
  const podminka = p?.referral_reward_condition;
  return useMemo(
    () => normOdmena({ castka, mena, podminka }, menaTenanta().code),
    [castka, mena, podminka],
  );
}

export { useOdmenaTipare };

/** Podpis zprávy s odkazem (jméno, pod ním pozice) z profilu poradce; mimo provider "". */
export function usePodpisDoporuceni() {
  const p = useProfilVolitelne()?.profile || null;
  return podpisDoporuceni(p);
}
